import { GetterTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyEnvironmentTypesStore from "./property-environment-types.store";
import { PropertyEnvironmentOptionView } from "../../../../models/property/property-environment-option-view.model";
import {PropertyEnvironmentAddressModel} from "../../../../models/property/property-environment.address.model";

const environmentGetters: GetterTree<IPropertyEditState, {}> = <GetterTree<IPropertyEditState, {}>>{
        service: (state: IPropertyEditState) => state.service,
        getListEnvironmentPictureType: (state: IPropertyEditState) =>
            state.environmentPictureType,
        [propertyEnvironmentTypesStore.Get.LIST_PROPERTY_ENVIRONMENT]: (
            state: IPropertyEditState
        ) => {
            return state.listOfSelectPropertyEnvironment || [];
        },
        [propertyEnvironmentTypesStore.Get.LIST_PICTURE_PROPERTY_ENVIRONMENT]: (
            state: IPropertyEditState
        ) => {
            return state.property.PicturesOfEnvironment;
        },
        [propertyEnvironmentTypesStore.Get.URL_PICTURE_FROM_STORAGE]: (
            state: IPropertyEditState
        ) => {
            return state.listOfPropertyEnvironmentPictureStorage || [];
        },
        [propertyEnvironmentTypesStore.Get.LIST_PROPERTY_ENVIRONMENT_POINT]: (
            state: IPropertyEditState
        ) => {
            return state.property.PoiOfEnvironment || [];
        },
        [propertyEnvironmentTypesStore.Get.LIST_PROPERTY_ENVIRONMENT_POINT_GROUP]: (
            state: IPropertyEditState
        ) => {
            return state.property.PoiOfEnvironment.Groups || [];
        },
        [propertyEnvironmentTypesStore.Get.LIST_PROPERTY_ENVIRONMENT_MAP_VIEW]: (
            state: IPropertyEditState
        ) => {
            return (
                state.property.PoiOfEnvironment.OptionView ||
                new PropertyEnvironmentOptionView({})
            );
        },
        [propertyEnvironmentTypesStore.Get.ENVIRONMENT_ADDRESS]: (state: IPropertyEditState) => {
            return state.environmentAddress || new PropertyEnvironmentAddressModel({});
        },
    };

export default environmentGetters;
